import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=51077c48&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=51077c48&prod&lang=css"
import style1 from "./Form.vue?vue&type=style&index=1&id=51077c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51077c48",
  null
  
)

export default component.exports